import "./ManageChat.scss";
import SendIcon from '@mui/icons-material/Send';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useEffect, useRef, useState } from "react";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { GetSessionStorageData, S3DataGetApi, checkValueNullUndefinedEmpty, uploadFileToS3 } from "../../../Services/Helpers/Helper";
import { ADMIN_ROLES, API_RESPONSE, COMMON_CONSTANTS, NUMBER_CONSTANTS, STORAGE_KEYS, VALIDATION_CONSTANT } from "../../../Utilities/Constants/Constants";
import chatImg from "../../../../Assets/global/chat_icon_violet.svg";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';
import AttachmentIcon from '@mui/icons-material/Attachment';
import FileViewerDialog from "../../../Shared/FileViewerDialog/FileViewerDialog";
import driveImg from "../../../../Assets/Registration/drive.svg";
import { setLoader, setNotificationData } from "../../../Services/Redux/Reducer/Reducer";
import { store } from "../../../Services/Redux/Store/Store";
import profileDefault from "../../../../Assets/global/profile_default.svg";

const ManageChat = () => {

  const [chatsList, setChatsList] = useState<any>([]);
  const [chatterData, setChatterData] = useState<any>()
  const [textMessage, setTextMessage] = useState("");
  const [activeIndex, setActiveIndex] = useState(NUMBER_CONSTANTS.MINUS_ONE);
  const [currentRoomData, setCurrentRoomData] = useState<any>({});
  const [chatHistory, setChatHistory] = useState<any>([]);
  const [userId, setUserId] = useState<any>("");
  const [socketInstance, setSocketInstance] = useState<any>();
  const [currentPage, setCurrentPage] = useState(NUMBER_CONSTANTS.ONE);
  const [totalPages, setTotalPages] = useState(NUMBER_CONSTANTS.ZERO);
  const [userSearchText, setUserSearchText] = useState("");
  const profileBtnRef = useRef<HTMLInputElement | null>(null);
  const [fileViewerOpen, setFileViewerOpen] = useState(API_RESPONSE.FALSE);
  const [viewerFile, setViewerFile] = useState("");
  const [newMessage, setNewMessage] = useState(API_RESPONSE.FALSE);
  const [prevChatRoom, setPrevChatRoom] = useState<any>(null)
  const dispatch = useDispatch();
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });
  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });
  const navigate = useNavigate();
  const { id } = useParams();
  const chatContainerRef: any = useRef(API_RESPONSE.NULL);
  let prevScrollHeight: any = useRef(NUMBER_CONSTANTS.ZERO);

  const notifiactionUser: any = useSelector((state: any) => {
    return state.notificationReducer.notification;
  });

  useEffect(() => {
    // This code will run when the component mounts
    return () => {
      setChatterData(null);
      dispatch(
        setNotificationData(
          ""
        ));
    };
  }, []);


  useEffect(() => {
    if (id !== notifiactionUser?.chat_room) {
      getChatsList();
    }

  }, [notifiactionUser])

  useEffect(() => {
    moment.locale('en');
    setUserId(GetSessionStorageData(STORAGE_KEYS.ID));
    if (checkValueNullUndefinedEmpty(id))
      getChatsList();
  }, []);

  useEffect(() => {

  }, [chatsList])

  useEffect(() => {
    // console.log(chatContainerRef.current,chatHistory?.length,newMessage,'on chat history',chatContainerRef.current.scrollTop)
    /* if (chatContainerRef.current && (currentPage===NUMBER_CONSTANTS.ONE || newMessage)) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight -200;
      setNewMessage(API_RESPONSE.FALSE);
    }else{
      if(chatContainerRef?.current)
        chatContainerRef.current.scrollTop = 100;
    } */
    if (chatContainerRef?.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
      const isScrolledToBottom = scrollTop + clientHeight >= scrollHeight - 200;

      if (isScrolledToBottom || newMessage || currentPage === NUMBER_CONSTANTS.ONE) {
        chatContainerRef.current.scrollTop = scrollHeight - 200;
        setNewMessage(API_RESPONSE.FALSE);
      } else {
        chatContainerRef.current.scrollTop = 100;
      }
    }

  }, [chatHistory]);

  const handleScroll = () => {
    const chatContainer = chatContainerRef.current;
    const { current } = chatContainerRef;
    //  console.log(current.scrollHeight - current.clientHeight <= current.scrollTop + 1,'00000')
    if (chatContainer.scrollTop === NUMBER_CONSTANTS.ZERO) {
      // When the user scrolls to the top, load more messages
      if (currentPage + 1 <= totalPages) {
        setCurrentPage(currentPage + 1)
      }
    }
    // console.log(chatContainer.scrollHeight,'scroll')

    /* if(current.scrollHeight -chatContainer.scrollTop ===390){
       setNewMessage(API_RESPONSE.TRUE);
     } */
  };

  useEffect(() => {
    if (currentRoomData && id && currentPage !== NUMBER_CONSTANTS.ONE) {
      getChatHistory(currentRoomData);
    }

  }, [currentPage]);

  useEffect(() => {
    if (id) {
      setPrevChatRoom(id);
      if (socketInstance) {
        socketInstance.close();
      };
      let socket = new WebSocket(`${process.env.REACT_APP_CHAT_WEB_SOCKET + id}/`);
      // let socket = new WebSocket(`wss://learnandplay.way2smile.ae:8001/ws/chat/${id}/`);
      // let socket = new WebSocket(`wss://phygital.way2smile.ae:8001/ws/chat/${id}/`);
      setSocketInstance(socket);
      setMessageRead();

    }
  }, [id]);

  /* chat read api*/
  const setMessageRead = () => {
    axiosInstance.put(API_END_POINTS.SET_USER_READ_CHAT, { "room_id": id })
      .then((response) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) { }
      })
  }

  useEffect(() => {
    if (socketInstance) {
      socketInstance.onopen = (event: any) => {
      };

      /* Listen to events for socket server */
      socketInstance.onmessage = (event: any) => {
        setChatHistory((prevChatHistory: any) => [...prevChatHistory, JSON.parse(event.data)]);
      };

      /* Closes socket on killing component */
      return () => {
        socketInstance.close();
      }
    }

  }, [socketInstance])

  /* Getting users list for chat */
  const getChatsList = () => {
    let spType = '';
    if (GetSessionStorageData(STORAGE_KEYS.ROLE) === ADMIN_ROLES.TUTOR) {
      spType = NUMBER_CONSTANTS.ONE;
    } else if (GetSessionStorageData(STORAGE_KEYS.ROLE) === ADMIN_ROLES.RECREATIONAL_CAMP) {
      spType = NUMBER_CONSTANTS.THREE;
    } else if (GetSessionStorageData(STORAGE_KEYS.ROLE) === ADMIN_ROLES.RECREATIONAL_PERSONAL) {
      spType = NUMBER_CONSTANTS.TWO;
    }
    axiosInstance.get(API_END_POINTS.CHAT_USERS_LIST + "?service_provider_type=" + spType + "&search=" + userSearchText + "&page=1" + "&limit=100").then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        // setChatsList([...chatsList,...response.data.result.data]);
        store.dispatch(setLoader(false));
        if (id && response?.data?.result?.data?.length > 0 /* && checkValueNullUndefinedEmpty(chatterData) */) {
          // setCurrentRoomData(id);
          let filterData = response?.data?.result?.data.findIndex((user: any, i: number) => {
            return user.chat_room_name === id;
          });
          setActiveIndex(response?.data?.result?.data[filterData]?.sender);
          if (prevChatRoom !== id)
            setChatterData(response?.data?.result?.data[filterData]);
          //  onClickUser(response?.data?.result?.data[filterData],filterData);

        }
        setChatsList(response.data.result.data);

      }
    })
  };

  /* Sending message using socket */
  const onSendMessage = () => {
    setNewMessage(API_RESPONSE.TRUE)
    if (textMessage.trim() !== '') {
      socketInstance.send(JSON.stringify({
        sender: userId,
        receiver: chatterData.child_auth_id,
        message: textMessage,
        image: null,
        document: null,
        room_id: currentRoomData.id
      }));
      setTextMessage("");

    }
  };
  const onSendMessageDoc = (imgMsg: any, dataType: any) => {
    setNewMessage(API_RESPONSE.TRUE)
    if (imgMsg.trim() !== '') {

      socketInstance.send(JSON.stringify({
        sender: parseInt(userId),
        receiver: chatterData.child_auth_id,
        message: null,
        image: dataType === 'image' ? imgMsg : null,
        document: dataType === 'document' ? imgMsg : null,
        room_id: currentRoomData.id
      }));

      setTextMessage("");
    }
  };

  useEffect(() => {
    if (chatterData && (currentRoomData?.room_name !== id || chatterData.chat_room_name !== id)) {
      createRoom();
    };
  }, [chatterData])

  /* Creating chat room on click user */
  const onClickUser = (data: any, index: any) => {
    if (chatterData !== data) {
      if (socketInstance) {
        socketInstance.close();
      }

      let userList: any = chatsList;
      userList[index].is_unread_msg_available = false;
      setChatsList([...userList]);
      // getChatsList();
      /* dispatch(
        setNotificationData(
         ""
        ));  */
      setTotalPages(NUMBER_CONSTANTS.ZERO);
      setCurrentPage(NUMBER_CONSTANTS.ONE);
      setActiveIndex(userList[index]?.sender);
      setTextMessage("");
      setChatHistory([]);
      setChatterData(data);
    }

  };

  const createRoom = () => {
    let spType = '';
    let userType = '';
    if (GetSessionStorageData(STORAGE_KEYS.ROLE) === ADMIN_ROLES.TUTOR) {
      spType = NUMBER_CONSTANTS.ONE;
      userType = VALIDATION_CONSTANT.TUTOR;
    } else if (GetSessionStorageData(STORAGE_KEYS.ROLE) === ADMIN_ROLES.RECREATIONAL_CAMP) {
      spType = NUMBER_CONSTANTS.THREE;
      userType = VALIDATION_CONSTANT.RECREATIONAL_CAMP;
    } else if (GetSessionStorageData(STORAGE_KEYS.ROLE) === ADMIN_ROLES.RECREATIONAL_PERSONAL) {
      spType = NUMBER_CONSTANTS.TWO;
      userType = VALIDATION_CONSTANT.RECREATIONAL_PERSONAL;
    }
    axiosInstance
      .post(API_END_POINTS.CREATE_CHAT_ROOM, {
        service_provider_type: spType,
        booking_id: chatterData.booking_id,
        type: userType,
        recipient_id: chatterData.child_auth_id,
      })
      .then((response) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          setCurrentRoomData(response.data.result.data);
          // if(id !== response.data.result.data.room_name){
          navigate(`/chat/${response.data.result.data.room_name}`);
          getChatHistory(response.data.result.data);
          // }

          if (currentPage === NUMBER_CONSTANTS.ONE)
            setCurrentPage(NUMBER_CONSTANTS.ONE);
        }
      });
  }

  const getChatHistory = (data: any) => {
    axiosInstance.post(API_END_POINTS.CHAT_HISTORY + "?room_id=" + data.id, {
      page: currentPage,
      limit: NUMBER_CONSTANTS.TEN
    }).then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        prevScrollHeight = chatContainerRef.current.scrollHeight;
        let responseData = response.data.result.data.reverse();
        setChatHistory([...responseData, ...chatHistory]);
        setTotalPages(response.data.result.total_page);

      }
    })
  }

  const onUploadEventImage = async (event: any) => {
    try {
      store.dispatch(setLoader(true));
      const uploadedImage = await S3DataGetApi(event);
      if (event.target.files[0].type.split("/")[0] === "image") {
        onSendMessageDoc(uploadedImage, 'image');
        store.dispatch(setLoader(false));
      } else {
        onSendMessageDoc(uploadedImage, 'document');
        store.dispatch(setLoader(false));
      }
    } catch (error) { }
  };


  /* Coverting intoo railway time */
  const convertRailwayTime = (time: any) => {
    moment.locale('en');
    return moment(time, COMMON_CONSTANTS.HMA_FORMAT).format(COMMON_CONSTANTS.HM_FORMAT);
  };


  const [userSearched, setUserSearched] = useState(API_RESPONSE.FALSE);
  const onSearchUser = () => {
    setUserSearched(API_RESPONSE.TRUE);
    getChatsList();
  }


  useEffect(() => {
    if (userSearchText === '' && userSearched) {
      getChatsList();
    }
  }, [userSearchText])

  const setUserText = (e: any) => {
    setUserSearchText(e.target.value);
  }
  /**Handle file viewer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(API_RESPONSE.FALSE);
    setViewerFile("");
  };

  /**Handle file viewer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(API_RESPONSE.TRUE);
  };


  return (
    <div className="chat-wrapper">
      <FileViewerDialog
        open={fileViewerOpen}
        handleClose={onFilerViewerDialogClose}
        viewerFile={viewerFile}
      ></FileViewerDialog>
      <div className="row">
        <div className="col-md-5">
          <div className="input-search-wrapper">
            <input className="search-input"
              placeholder="Search"
              value={userSearchText}
              onChange={setUserText}
              onKeyPress={(e: any) => {
                if (e.code === VALIDATION_CONSTANT.KEY_TYPE) {
                  if (userSearchText.trim() === '') {
                    e.preventDefault();
                  } else {
                    onSearchUser()
                    e.preventDefault();
                  }
                }

              }}
            />
            <SearchIcon className="search-icon" onClick={onSearchUser} />
          </div>
          <div className="chat-list-wrapper">
            {
              chatsList.map((user: any, index: any) => {
                return (
                  // <div>
                  <div key={index + 1} className={activeIndex === user.sender ? "chat-list-active" : "chat-list"} onClick={() => onClickUser(user, index)}>
                    {/*  <div>
                      <div className="dot-div"></div>
                    </div> */}
                    <div className={user?.is_unread_msg_available ? "profile-wrap" : 'profile-wrap-empty'}>
                      <img className="chat-user-profile" src={user.image ? user.image : profileDefault} />
                    </div>
                    <div className="name-desc-wrapper">
                      <p className="user-name-left">{user.firstname}</p>
                      {/* <p className="parent-name"><span>Messaging by: </span>{user.parent_name}</p> */}
                      <p className="last-message">{user.last_message}</p>
                    </div>
                    <div>
                      <p className="timer">{user?.last_msg_time ?
                        moment(user?.last_msg_time).format(COMMON_CONSTANTS.HM_FORMAT)
                        : ""}</p>
                    </div>
                    <hr className="" />
                  </div>
                )
              })
            }
          </div>

        </div>
        <div className="col-md-7">
          <div className="chat-detail-wrapper">
            <div className="user-name">
              <h5>{chatterData ? chatterData?.firstname : ''}</h5>
            </div>
            <div className="user-chat">
              {activeIndex != -1 &&
                <div className="chats" ref={chatContainerRef} onScroll={handleScroll}>
                  {chatHistory.map((chat: any, i: any) => {
                    return (
                      <>
                        {chat.sender != userId &&
                          <>
                            {chat.message && <div className="end-chat-time-wrapper">
                              <div className="end-user-chat">
                                <p className="end-user-message">{chat.message}</p>

                              </div>
                              <p className="end-time">{moment(chat.created_on).format(COMMON_CONSTANTS.HM_FORMAT)}</p>
                            </div>}

                            <div className="end-chat-time-wrapper">
                              {chat.image && <div className="end-user-chat-img">
                                <img className="chat-image" src={chat.image} onClick={() => {
                                  onFilerViewerDialogOpen(chat.image);
                                }} />
                              </div>}
                            </div>

                            <div className="end-chat-time-wrapper">
                              {chat.document && <div className="end-user-chat-img">
                                <img className="chat-document" src={driveImg} onClick={() => {
                                  // onFilerViewerDialogOpen(chat.message);
                                  window.open(chat.document, "_blank");

                                }} />
                                <p className="document-text">{chat.document.split("/")[
                                  chat.document.split("/").length - 1
                                ]
                                }</p>
                              </div>}


                            </div>

                          </>
                        }
                        {chat.sender == userId &&
                          <>
                            {chat.message && <div className="user-chat-time-wrapper">
                              <div className="user-one-chat">
                                <p>{chat.message}</p>

                                <p className="end-time">{moment(chat.created_on).format(COMMON_CONSTANTS.HM_FORMAT)}</p>
                              </div>


                            </div>}
                            <div className="user-chat-time-wrapper">
                              {chat.image && <div className="user-one-chat-img">
                                <img className="chat-image" src={chat.image} onClick={() => {
                                  onFilerViewerDialogOpen(chat.image);
                                }} />
                              </div>}


                            </div>

                            <div className="user-chat-time-wrapper">
                              {chat.document && <div className="user-one-chat-img">
                                <img className="chat-document" src={driveImg} onClick={() => {
                                  // onFilerViewerDialogOpen(chat.message);
                                  window.open(chat.document, "_blank");
                                }} />
                                <p className="document-text">{chat.document?.split("/")[
                                  chat.document?.split("/").length - 1
                                ]
                                }</p>
                              </div>}



                            </div>
                          </>


                        }
                      </>

                    )
                  })}
                </div>

              }
              {activeIndex != -1 && <div className="message-input-wrapper">
                <div className="input-send-wrapper">
                  <div className="input-icon-wrapper">
                    <textarea placeholder="Write your message..." rows={NUMBER_CONSTANTS.ONE} value={textMessage} onChange={(e: any) => {
                      setTextMessage(e.target.value);
                    }}

                      /* onKeyPress={(e:any)=>{
                         if(e.code===VALIDATION_CONSTANT.KEY_TYPE){
                            if(textMessage.trim() ===''){
                                e.preventDefault();
                            }else{
                                onSendMessage();
                                e.preventDefault();
                            }
                         }
                            
                      }} */
                      onKeyPress={(e: any) => {
                        if (e.key === VALIDATION_CONSTANT.KEY_TYPE) {
                          if (e.shiftKey) {
                            setTextMessage((prevText) => prevText + '\n');
                          } else if (textMessage.trim() === '') {
                            e.preventDefault();
                          } else {
                            onSendMessage();
                            e.preventDefault();
                          }
                        }
                      }}
                    />
                    <input
                      type="file"
                      // accept="image/png, image/jpg, image/jpeg, image/svg,application/pdf"
                      accept="image/png, image/jpeg, image/jpg, image/svg+xml, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      className="input-upload"
                      onChange={(e: any) => {
                        onUploadEventImage(e);
                      }}
                      ref={profileBtnRef}
                      style={{ display: "none" }}
                    />
                    {/* <button
                            className="select-file-btn"
                            onClick={() => {
                              profileBtnRef.current?.click();
                            }}
                          >
                            SELECT FILE
                          </button> */}

                    <AttachFileIcon className="attach-file-icon"
                      onClick={() => {
                        profileBtnRef.current?.click();
                      }} />
                  </div>

                  <button className="btn btn-primary send-btn" onClick={onSendMessage}>Send <SendIcon className="send-icon" /></button>
                </div>
              </div>}

              {
                activeIndex === -1 && <div className="initial-image-wrapper">
                  <img src={chatImg} className="chat-image" />
                  <p className="start-msg">Please click on the users to start chat</p>
                </div>
              }
            </div>

          </div>
        </div>

      </div>
    </div>
  )
};

export default ManageChat;